module.exports = __webpack_public_path__ + "static/jekyll-0f1a28977e28ae19f28016042e36fb09.png";